import _ from 'lodash';
import grid from 'utils/lsp-grid/grid';
import smsHelpers from '../helpers/sms-helpers';
import manageSmsNotificationDialogLogic from '../components/manage-sms-notification/components/manage-sms-notification-dialog/manage-sms-notification-dialog-logic';

const DEFAULT_SORT_COLUMN = 'templateTypeName';
const DEFAULT_SORT_DIRECTION = true;

function initializeModel(deps, model) {
  return _.merge(model, {
    rawSmsTypes: [],
    userSmsCategories: {},
    loginNotificationPopup: {
      types: {},
      data: {},
    },
    notificationTemplates: {
      smsGrid: grid.applyGrid(deps, smsTemplatesList.bind(null, deps), 'notificationTemplates.smsGrid', {
        [deps.config.pageSizeKey]: deps.config.defaultPageSize[2],
        [deps.config.sortColumnKey]: DEFAULT_SORT_COLUMN,
        [deps.config.directionKey]: DEFAULT_SORT_DIRECTION,
        locale: model.session.locale,
      }),
      smsTemplates: {},
      smsTemplate: {
        language: model.session.locale,
        languageValidation: {},
        params: [],
      },
      smsList: {
        language: model.session.locale,
        languageValidation: {},
      },
    },
  });
}

function loadDictionaries(deps, model) {
  return loadSmsTypes(deps, model);
}

function loadSmsTypes(deps, model) {
  const { session: { locale } } = deps.$ngRedux.getState();

  return deps.restSrv.list(undefined, model.session.rest.dictionary.smsTypes.url, null, { locale }).then((subscriptions) => {
    model.rawSmsTypes = subscriptions;
    model.dictionary.smsTypes = smsHelpers.subscriptions2Object(subscriptions);
    return model;
  });
}

function smsTemplatesList(deps, model) {
  return deps.restSrv.list(undefined, model.session.rest.smsNotifications.templates.url, { locale: '*', templateEditable: true }).then((data) => Object.keys(data).reduce((reduced, langKey) => {
    reduced[langKey] = _.sortBy(data[langKey], [DEFAULT_SORT_COLUMN]);
    return reduced;
  }, {}));
}

function smsLoginNotificationTypes(deps, model) {
  return deps.restSrv
    .list(undefined, model.session.rest.smsNotifications.templates.url, {
      locale: '*',
      smsGroup: 'LOGIN_POP_UP',
    })
    .then((types) => {
      model.loginNotificationPopup.types = Object.keys(types).reduce((reduced, langKey) => {
        const langArray = types[langKey];
        reduced[langKey] = reduced[langKey] || {};
        reduced[langKey] = langArray.map((item) => ({
          smsTypeId: item.smsTypeId,
          smsTemplateId: item.smsTemplateId,
          smsTypeTxt: item.smsTypeTxt.split(' ')[0],
        }));
        return reduced;
      }, {});
      return model;
    });
}

function fetchTemplate(deps, model, templateId) {
  return deps.restSrv.list(undefined, model.session.rest.smsNotifications.template.get.url, null, { templateId }).then((data) => {
    model.notificationTemplates.smsTemplate[templateId] = smsHelpers.transformSmsTemplate4Multilang(model.rawSmsTypes, data);
    model.notificationTemplates.smsTemplate.params = _.get(data, 'params');
    return model;
  });
}

function updateTemplate(deps, model, templateId) {
  const template = _.cloneDeep(model.notificationTemplates.smsTemplate[templateId]);
  return deps.restSrv.update(undefined, model.session.rest.smsNotifications.template.update.url, smsHelpers.transformMultilangTemplate4Save(deps, template), { templateId }).then(() => fetchTemplate(deps, model, templateId));
}

function updateSmsData4LoginPopup(deps, model, params) {
  const {
    path, smsEnabled, smsType, smsTemplate,
  } = params;
  const langObj = _.get(model, path);
  return Promise.resolve(
    _.set(
      model,
      path,
      Object.keys(langObj).reduce((reduced, langKey) => _.flow([(obj) => _.set(obj, `${langKey}.smsEnabled`, smsEnabled), (obj) => _.set(obj, `${langKey}.smsType`, smsType), (obj) => _.set(obj, `${langKey}.smsTemplate`, smsTemplate)])(reduced), langObj),
    ),
  );
}

export default ({

  initializeModel,
  fetchTemplate,
  loadDictionaries,
  smsTemplatesList,
  updateTemplate,
  smsLoginNotificationTypes,
  updateSmsData4LoginPopup,
  ...manageSmsNotificationDialogLogic,
});



// WEBPACK FOOTER //
// ./src/modules/sms/logic/sms.js